import { graphql } from '@/generated/gql';

export const COUNTRY_REPORT_LIST_WIDGET_QUERY = graphql(/* GraphQL */ `
  query CountryReportListWidget {
    cataclysm {
      countryReports {
        id
        name
        description
        publishedAt
      }
    }
  }
`);
